// removed by extract-text-webpack-plugin
module.exports = {"containerWrap":"qempo_VerificationBanner_containerWrap-2GOrvsX","contentWrap":"qempo_VerificationBanner_contentWrap-3j_vVQB","textWrap":"qempo_VerificationBanner_textWrap-17FH61k","buttonWrap":"qempo_VerificationBanner_buttonWrap-1wHR8cM","closeButton":"qempo_VerificationBanner_closeButton-2h_lJD5"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/VerificationBanner/VerificationBanner.scss
// module id = 1693
// module chunks = 0